import { categories } from '@/mocks/manga';

interface Props {
  onSelect: (key: string) => void;
}

export default function Categories({ onSelect }: Props) {
  return (
    <section id="categories" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-grid-fill" />
            分类导航
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            按题材快速找到你的女神系漫画
          </h2>
          <p className="mt-3 max-w-2xl text-sm text-foreground-600">
            我们按题材整理了六大女神系漫画分类，点击任意分类即可筛选下方热门推荐，快速定位你感兴趣的领域。
          </p>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c) => (
          <button
            key={c.key}
            type="button"
            onClick={() => onSelect(c.key)}
            className="group flex cursor-pointer items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 text-left transition-all hover:-translate-y-0.5 hover:border-primary-200 hover:bg-background-100"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${c.icon} text-xl`} />
            </span>
            <span className="min-w-0">
              <span className="flex items-center justify-between">
                <span className="font-heading text-base font-bold text-foreground-900">{c.name}</span>
                <span className="text-xs text-foreground-400">{c.count} 部</span>
              </span>
              <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">{c.desc}</span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}